<div class="toolbar">
  <app-container-standard title="Svinn Report">
    <div class="form-row">

      <div class="form-group col-md-4">
        <mat-form-field class="example-full-width">
          <mat-select [formControl]="systemControl">
            <mat-option value="all">
              All systems
            </mat-option>
            <mat-option *ngFor="let option of filteredSystems$ | async" (click)="setSystem(option)"
              [value]="option.systemId">
              {{ option.systemName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-select placeholder="Select system" [formControl]="categoryControl">
            <mat-option value="all">
              All categories
            </mat-option>
            <mat-option *ngFor="let option of categories$ | async" (click)="setCategory(option)" [value]="option.name">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="select-time-period">
          <mat-select placeholder="Select time period" [(value)]="timeSelected"
            (selectionChange)="setTimePeriodeEvent($event)">
            <mat-option value="LAST-7-DAYS">Last 7 days</mat-option>
            <mat-option value="TODAY" selected>Today</mat-option>
            <mat-option value="YESTERDAY">Yesterday</mat-option>
            <mat-option value="24H">Last 24 hours</mat-option>
            @if (showExtraDateOptions()) {
            <mat-option value="THIS_MONTH">This month</mat-option>
            <mat-option value="LAST_MONTH">Last month</mat-option>
            <mat-option value="CUSTOM">Customized</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-checkbox class="checkbox" [(ngModel)]="excludeWeekends"><span class="checkbox-text">Exclude weekends</span></mat-checkbox>
  <mat-checkbox class="checkbox" [(ngModel)]="aggregateCategoriesOnly"><span class="checkbox-text">Aggregate across systems (categories only)</span></mat-checkbox>
      </div>

    </div>
    <ng-container *ngIf="timeSelected == 'CUSTOM' && (categoryControl.value != 'all' || systemControl.value != 'all')">
      <mat-form-field>
        <mat-label>Custom Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" (dateChange)="setCustomRange($event, 'start')">
          <input matEndDate placeholder="End date" (dateChange)="setCustomRange($event, 'end')">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </ng-container>
    <div class="button-row create-button">
      <button (click)="onSubmit()" class="theme-primary white-text float-right" mat-flat-button>Create</button>
    </div>

  </app-container-standard>
</div>

@if(svinnData$ | async){
<app-table-standard-layout [dataSource$]="svinnData$" [columnSettings]="columnSettings" [title]="'Svinn Report'"
  [rowActionButtons]="actionButtons"></app-table-standard-layout>
} @else if (loading && isLargeQuery()) {
<div><app-spinner-loading></app-spinner-loading>
  <div class="info-message" style="margin: auto; text-align: center;">
    <p>This query might take a while to process. Please be patient.</p>
  </div>
</div>
} @else if (loading) {
<app-spinner-loading></app-spinner-loading>
}

<!-- <div class="table-container mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

    <tr *ngFor="let column of displayedColumns" [matColumnDef]="column">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column | titlecase }} </th>
      <td mat-cell *matCellDef="let element" class="divider-cell"> {{ element[column] }} </td>
      <td mat-footer-cell *matFooterCellDef> {{ columnTotals[column] }} </td>

    </tr>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

  </table>
</div> -->